// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"493":"a772af0d","924":"2c82adf2"}[chunkId] + ".chunk.js";
};